import { render, staticRenderFns } from "./ThePageTitleBar.vue?vue&type=template&id=55dec3e9&scoped=true&"
import script from "./ThePageTitleBar.vue?vue&type=script&lang=js&"
export * from "./ThePageTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./ThePageTitleBar.vue?vue&type=style&index=0&id=55dec3e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dec3e9",
  null
  
)

export default component.exports